import { Injectable } from '@angular/core';
import {
  MessagesActionToggleLoading,
  MessagesPageToggleLoading,
} from '../_actions/message.actions';

@Injectable()
export class MessageEffects {
  showPageLoadingDistpatcher = new MessagesPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new MessagesPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new MessagesActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new MessagesActionToggleLoading({ isLoading: false });
}
